export const CURRENT_USER_START='CURRENT_USER_START';
export const CURRENT_USER_SUCCESS='CURRENT_USER_SUCCESS';
export const CURRENT_USER_FAIL='CURRENT_USER_FAIL';

export const SAVE_FCM_TOKEN_START='SAVE_FCM_TOKEN_START';
export const SAVE_FCM_TOKEN_SUCCESS='SAVE_FCM_TOKEN_SUCCESS';
export const SAVE_FCM_TOKEN_FAIL='SAVE_FCM_TOKEN_FAIL';

export const UPDATE_USER_BALANCE='UPDATE_USER_BALANCE';